module.exports = {
  back: 'Terug',
  cancel: 'Annuleer',
  confirm: 'Bevestig',
  send: 'Verzenden',
};



// WEBPACK FOOTER //
// ./js/lang/nl/actions.js